<template>
  <div style="width:100%; padding-top: 60px; overflow-x: auto;">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>
    <table style="font-size:12px; width: max-content;">
      <thead>
      <tr>
        <th style="width: 50px;" class="text-center" rowspan="2">序号</th>
        <th colspan="4" class="text-center">国内物流信息</th>
        <th colspan="4" class="text-center">国际物流信息</th>
        <th colspan="5" class="text-center">商品信息</th>
      </tr>
      <tr>
        <th style="width: 120px;" class="text-center">境内运输车牌号</th>
        <th style="width: 100px;" class="text-center">发车日期</th>
        <th style="width: 120px;" class="text-center">实际到达口岸时间</th>
        <th style="width: 100px;" class="text-center">换装结束时间</th>
        <th style="width: 120px;" class="text-center">国际运输车牌号</th>
        <th style="width: 100px;" class="text-center">换装日期</th>
        <th style="width: 120px;" class="text-center">到达目的地名称</th>
        <th style="width: 130px;" class="text-center">实际到达目的地时间</th>
        <th style="width: 100px;" class="text-center">商品名称</th>
        <th style="width: 100px;" class="text-center">产品品牌</th>
        <th style="width: 80px;" class="text-center">产品等级</th>
        <th style="width: 80px;" class="text-center">发车件数(筐)</th>
        <th style="width: 100px;" class="text-center">不含筐总重(斤)</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in items" :key="index">
        <!-- 序号 -->
        <td style="width: 50px;" class="text-center">{{ index + 1 }}</td>

        <!-- 国内物流信息列组（只在第一行显示，合并所有行） -->
        <td v-if="index === 0" :rowspan="items.length" style="width: 120px;" class="text-center">
          {{ item.inCarNo }}
        </td>
        <td v-if="index === 0" :rowspan="items.length" style="width: 100px;" class="text-center">
          {{ item.inDepartureDate }}
        </td>
        <td v-if="index === 0" :rowspan="items.length" style="width: 120px;" class="text-center">
          {{ item.inArrivalDate }}
        </td>
        <td v-if="index === 0" :rowspan="items.length" style="width: 100px;" class="text-center">
          {{ item.inChangeDate }}
        </td>

        <!-- 国际物流信息 -->
        <td style="width: 120px;" class="text-center">{{ item.outCarNo }}</td>
        <td style="width: 100px;" class="text-center">{{ item.outChangeDate }}</td>
        <td style="width: 120px;" class="text-center">{{ item.outAddress }}</td>
        <td style="width: 130px;" class="text-center">{{ item.outArrivalDate }}</td>

        <!-- 商品信息 -->
        <td style="width: 100px;" class="text-center">{{ item.goodsName }}</td>
        <td style="width: 100px;" class="text-center">{{ item.brandName }}</td>
        <td style="width: 80px;" class="text-center">{{ item.varietyLevelLabel }}</td>
        <td style="width: 80px;" class="text-center">{{ item.outboundNum }}</td>
        <td style="width: 100px;" class="text-center">{{ Number(item.totalWeightExcludePack).toFixed(4) }}</td>
      </tr>
      </tbody>
<!--      <tfoot>-->
<!--      <tr>-->
<!--        <td></td>-->
<!--        <td colspan="4" class="text-center">合计</td>-->
<!--        <td></td>-->
<!--        <td></td>-->
<!--        <td></td>-->
<!--        <td></td>-->
<!--        <td></td>-->
<!--        <td></td>-->
<!--        <td></td>-->
<!--        <td class="text-center">{{ sumNum(items, 'outboundNum', 0) }}</td>-->
<!--        <td class="text-center">{{ sumNum(items, 'totalWeightExcludePack') }}</td>-->
<!--      </tr>-->
<!--      </tfoot>-->
    </table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";

export default {
  name: "ItsSalesOuterAbroadDetail",
  data() {
    return {
      items: []
    }
  },
  created() {
    const data = JSON.parse(this.$route.query.data || '[]')
    this.items = this.processData(data)
  },
  methods: {
    processData(list) {
      // 处理数据，添加字典标签
      return list.map(item => ({
        ...item,
        // 如果有字典值，这里可以添加对应的标签
        varietyLevelLabel: item.varietyLevel || ''
      }))
    },
    goBack() {
      this.$router.back()
    },
    // 合计计算
    sumNum(arr, key, n = 2) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(n, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    }
  }
}
</script>

<style scoped>
table {
  width: max-content;
  border-collapse: collapse;
  table-layout: fixed;
}

th, td {
  padding: 8px;
  text-align: left;
  border: 1px solid #ddd;
}

th {
  border: 1px solid #ddd;
  background-color: #f4f4f4;
  text-align: center;
}

.text-center {
  text-align: center;
}
</style>
